<p-dialog modal="true" appendTo="body" [(visible)]="display" (onHide)="onDialogHide()" [resizable]="false"
  [style]="{'width': '400px'}">

  <p-header>
    <span>Add Manual Link</span>
  </p-header>

  <device-selector [header]="'Select a Device'" [(visible)]="showSelector"
    [minDevices]="1" [maxDevices]="1"
    (onCancel)="onCancel()" (onOk)="onOk($event)">
  </device-selector>

  <div>
    <label for="device1">Device</label><br />

    <div>
      <input type="text" pInputText placeholder="" [ngModel]="deviceOne.DisplayName" disabled="disabled"
        class="input-field">
        <button class="btn btn-secondary btn-search" (click)="showDeviceList(1)">
          <i class="fa fa-search"></i>
        </button>
      </div>
    </div>

    <div>
      <label for="interface1">Interface/Port</label><br />
      <select [(ngModel)]="ifOne" class="input-field">
        @for (i of ifListOne; track i) {
          <option [ngValue]="i">{{i.DisplayName}}</option>
        }
      </select>
    </div>

    <div>
      <label>Device</label><br />
      <div>
        <input type="text" pInputText placeholder="" [ngModel]="deviceTwo.DisplayName" disabled="disabled"
          class="input-field">
          <button class="btn btn-secondary btn-search" (click)="showDeviceList(2)">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>

      <div>
        <label for="interface2">Interface/Port</label><br />
        <select [(ngModel)]="ifTwo" class="input-field">
          @for (i of ifListTwo; track i) {
            <option [ngValue]="i">{{i.DisplayName}}</option>
          }
        </select>
      </div>

      <p-footer>
        <button type="button" [disabled]="!devicesSelected" pButton icon="fa fa-check" (click)="hideDialog(); addNewLink()" label="Save"></button>
        <button type="button" pButton icon="fa fa-close" (click)="hideDialog(); reset()" label="Cancel"></button>
      </p-footer>

    </p-dialog>
